<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Pick GPS Device From Ship</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Pick GPS Device From Ship</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <ion-item>
            <ion-label position="floating">Ship <span class="required">*</span></ion-label>
            <ion-select mode="ios" @IonChange="shipChanged" interface="action-sheet" v-model="postData['ship_id']">
                <ion-select-option  v-for="(ship,i) of ships" :key="i" :value="ship.id"><strong>{{ship.ship_name}}</strong>, {{ship.owner.client_name}}, {{ship.owner.company.company_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">GPS Device <span class="required">*</span></ion-label>
            <ion-input v-model="deviceSerial" readonly></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Status <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['status']">
                <ion-select-option value="Good">Good</ion-select-option>
                <ion-select-option value="Faulty">Faulty</ion-select-option>
                <ion-select-option value="Dead">Dead</ion-select-option>
                <ion-select-option value="Damaged">Damaged</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item v-if="postData['status']=='Faulty' || postData['status']=='Damaged' || postData['status']=='Dead'">
            <ion-label position="floating">Issue <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="issueList">
                <template v-if="postData['status']=='Faulty' || postData['status']=='Damaged'">
                  <ion-select-option value="Charge Issue">Charge Issue</ion-select-option>
                  <ion-select-option value="Signal Issue">Signal Issue</ion-select-option>
                  <ion-select-option value="GPS Issue">GPS Issue</ion-select-option>
                </template>
                <template v-if="postData['status']=='Dead'">
                  <ion-select-option value="Short circuit">Short circuit</ion-select-option>
                  <ion-select-option value="Broken">Broken</ion-select-option>
                  <ion-select-option value="Water Damage">Water Damage</ion-select-option>
                  <ion-select-option value="Intentional Damage">Intentional Damage</ion-select-option>
                </template>
                <ion-select-option value="Other">Other</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item v-if="issueList=='Other'">
            <ion-label position="floating">Other Issue <span class="required">*</span></ion-label>
            <ion-textarea mode="ios" v-model="issue"></ion-textarea>
        </ion-item>
        <ion-button expand="block" @click="pick()" color="primary">Pick GPS Device</ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script >
import { IonButtons, IonButton, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, IonLabel,IonSelect,IonSelectOption,alertController, IonInput, IonTextarea } from '@ionic/vue';
import Loading from '../Loading';
export default {
  name: 'Pick GPS Device From Ship',
  data(){
    return {
    companies:[],
    company:'',
    gpsDevices:[],
    gpsDevice:'',
    clients:[],
    ships:[],
    issueList:null,
    issue:null,
    postData:{
        'ship_id':null,
        'gps_device_id':null,
        'status':null,
    },
    deviceSerial:null,
    }
  },
  created(){
    this.loadData();
  },
  methods:{
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async loadData(){
      this.postData['ship_id']=null;
      this.$http.post('myPickableGpsDevicesAndShips',
      {
        'username':window.localStorage.username,
        'password':window.localStorage.password
      }
      ).then(response=>{
        this.gpsDevices=[];
        this.ships=[];
        for(const data of response.data){
            if(data.ship!=null){
                this.ships.push(data.ship);
                if(data.ship.gps_device!=null && data.ship.gps_device.gps_device!=null){
                    this.gpsDevices.push({
                    name:data.ship.gps_device.gps_device.serial,
                    value:data.ship.gps_device.gps_device.id
                });
                }
            }
        }
        // console.log(this.ships,this.gpsDevices);
        // this.gpsDevices=response.data;
      });
    },
    shipChanged(){
      console.log(this.postData.ship_id);
      for(const ship of this.ships){
        if(ship.id==this.postData.ship_id){
          console.log('got');
          if(ship.gps_device!=null){
            this.deviceSerial=ship.gps_device.gps_device.serial,
            this.postData['gps_device_id']=ship.gps_device.gps_device.id
          }
          break;
        }
      }
    },
    async pick(){
        const requireds=[
            'ship_id',
            'gps_device_id',
            'status',
        ];
        for(const required of requireds){
            if(this.postData[required]=='' || this.postData[required]==null){
                let name=required;
                name=name.replace('_id','');
                name=name.replace('_',' ');
                this.presentAlert(name);
                return;
            }
        }
        if(this.postData['status']=='Damaged' || this.postData['status']=='Faulty' || this.postData['status']=='Dead'){
          if(this.issueList=='' || this.issueList==null){
                this.presentAlert('Issue');
                return;
          }
          if(this.issueList=='Other'){
            if(this.issue=='' || this.issue==null){
                this.presentAlert('Other Issue');
                return;
            }else{
              this.postData['issue']=this.issue;
            }
          }else{
            this.postData['issue']=this.issueList;
          }
        }
        const data=this.postData;
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('pickGpsDeviceFromShip',data).then(response=>{
        if(response.status==200){
            this.postData={
                'ship_id':null,
                'gps_device_id':null,
                'status':null,
            }
        this.company=null;
        this.gpsDevice=null;
          this.presentResponseAlert('Success','GPS Device picked successfully');
          this.loadData();
          this.postData['issue']=null;
          this.issue=null;
          this.issueList=null;
          this.deviceSerial=null;
        }
      });      
    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
    async companyChanged(){
        const loading = await Loading.presentLoading('Loading');
        this.postData['company_id']=this.company.value;
        this.postData['client_id']=null;
        this.$http.get('getClient',{params:{id:this.company.value}}).then(response=>{
            this.clients=response.data;
            loading.dismiss();
        });
    },
    async clientChanged(){
        this.postData['ship_id']=null;
        const loading = await Loading.presentLoading('Loading');
        this.$http.get('getShip',{params:{id:this.postData['client_id']}}).then(response=>{
            this.ships=response.data;
            loading.dismiss();
        });
    },
    gpsDeviceChanged(){
        this.postData['gps_device_id']=this.gpsDevice.value;
    },
  },
  components: {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonInput,
    IonTextarea
  }
  
}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.p-dropdown{
width: 100%;
color:#000;
}
.required{
  color:rgb(233, 0, 0)
}
</style>